import React from 'react';
// duperbrowse context, for internal use only
export var DuperbrowseStreamContext = React.createContext({
    stream: {
        items: [],
        streamId: '',
    },
    loadDuperbrowse: function () { return null; },
});
//# sourceMappingURL=DuperbrowseStreamContext.js.map